import { colors } from "@mui/material";

const palette = {
  primary: {
    500: "#EED3CB",
    600: "#ED5E32",
    main: "#DB572F",
  },

  secondary: {
    main: "#EAE7E6",
  },

  text: {
    primary: "#968682",
    secondary: "#5B4943"
  },

  green: {
    main: "#009D0E",
  },

  red: {
    main: "#9D0000",
    secondary: "#DF0000",
  },

  error: {
    main: "#9D0000",
  },

  background: {
    main: "#F9F4F2",
    secondary: "#D9D9D9",
  },

  disabled: {
    primary: "#8AB2B2",
    secondary: "#D2D2D2",
    text: "#7A7F7F",
    delete: "#A57878",
  },

  // accent color
  black: {
    main: colors.common.black,
    2: "#262B2B",
    3: "#373737",
    4: "#3E3E3E",
    opacity005: "rgba(0, 0, 0, 0.05)"
  },

  gray: {
    main: "#8E8E93",
  },

  white: {
    main: colors.common.white,
    2: "#F6F6F6",
    3: "#DDDDDD",
    4: "#6f6f6f",
    5: "#E1E1E1",
    55: "#E5E5E5",
    6: "#E8E8E8",
    7: "#D6D6D6",
    opacity40: "#FFFFFF61",
    dark: "#979797",
  },
};

export default palette;
